export default __webpack_public_path__ + "static/media/Group 11867.86993867.svg";